// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    stopWatchingForOtherTabSessionChange,
    watchForOtherTabSessionChange,
} from "@insite/client-framework/Services/SessionService";
import {
    AddAccount,
    chain,
    UnassignCartFromGuest,
} from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { xLoadingOverlay } from "@rpsc/App/Handlers/XNG/Common";
import { customAddAccount as xAddAccountApi } from "@rpsc/App/Services/CreateAccountService";
import { CustomAppState } from "@rpsc/App/Store/Reducers";

type HandlerType = typeof UnassignCartFromGuest;

export const setIsLoading: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "add", value: "add_account" }));
};

export const setLoadingCompleted: HandlerType = props => {
    props.dispatch(xLoadingOverlay({ key: "clear", value: "add_account" }));
};

// XNG-Changes: use custom service
export const XngAddAccount: HandlerType = async props => {
    try {
        stopWatchingForOtherTabSessionChange();
        const { basicInfo, billingAndShippingInfo } = (props.getState() as CustomAppState).xCreateAccount.accountInfo;

        const { confirmPassword, ...restBasicInfo } = basicInfo;
        const isGuestPlusAccount = (props.apiParameter.account as any).isGuestPlusAccount;
        props.apiResult = await xAddAccountApi({
            account: isGuestPlusAccount
                ? ({
                      ...restBasicInfo,
                      isGuestPlusAccount: true,
                      billTo: billingAndShippingInfo.billTo,
                      shipTo: billingAndShippingInfo.shipToSameAsBillTo ? null : billingAndShippingInfo.shipTo,
                      shipToSameAsBillTo: billingAndShippingInfo.shipToSameAsBillTo,
                  } as any)
                : props.apiParameter.account,
        });
        watchForOtherTabSessionChange();
    } catch (error) {
        props.apiResult = error.errorJson.message;
    }
};

addToStartOfChain(chain, setIsLoading);
addToEndOfChain(chain, setLoadingCompleted);
replaceInChain(chain, AddAccount, XngAddAccount);
